import React, { useState, useEffect } from 'react'
import { Route, Redirect, useHistory, useLocation } from 'react-router-dom'
import { useAuth } from './auth/Auth'
import Loader from './navigationComponents/loader/Loader'
import { useData } from './data/DataProvider'

const PrivateRoute = (props) => {
    const [isLoading, setIsLoading] = useState(true)

    const { component: Component, ...rest } = props
    const history = useHistory()
    const location = useLocation()

    const auth = useAuth()
    const data = useData()

    useEffect(() => {
        if (auth.isInstaller) {
            history.push('/installer-dashboard')
        } else if (auth.isConsumerGuest() && !data.isSetupComplete) {
            history.push('/setup/payment-info')
        } else if (
            location.pathname.startsWith('/setup') &&
            data.isSetupComplete === true
        ) {
            history.push('/dashboard')
        } else if (
            auth.isInstaller === false &&
            data.isSetupComplete === false &&
            !location.pathname.startsWith('/setup')
        ) {
            history.push('/setup/select-property')
        }
    }, [location.pathname, data.isSetupComplete, auth.isInstaller, history])

    useEffect(() => {
        setIsLoading(true)
        auth.isUserLoggedIn()
            .then((user) => {
                // data.loadInitialData()
            })
            .catch((error) => {
                auth.signout()
                history.push('/sign-in')
            })
            .finally(() => setIsLoading(false))
    }, [])

    return (
        <Route
            {...rest}
            render={({ location }) =>
                isLoading || !data.initComplete ? (
                    <Loader />
                ) : auth.isAuthenticated ? (
                    props.componentToReturn
                ) : (
                    <Redirect
                        to={{
                            pathname: '/sign-in',
                            state: { from: location },
                        }}
                    />
                )
            }
        />
    )
}

export default PrivateRoute
